// Wizard workflows config: role → list of workflows → ordered steps.
// Each step has a route (admin or staff portal). The wizard will auto-login
// with the role's demo account, then navigate to that route.

export const DEMO_EMAIL_BY_ROLE = {
  ceo: "ceo@thanhson.vn",
  admin: "admin@thanhson.vn",
  manager: "manager@thanhson.vn",
  hr: "hr@thanhson.vn",
  finance: "finance@thanhson.vn",
  restaurant: "staff@thanhson.vn",
  kitchen: "kitchen@thanhson.vn",
  warehouse: "warehouse@thanhson.vn",
};

export const ROLES = [
  { role: "ceo", label: "CEO / Chủ doanh nghiệp", desc: "Toàn quyền điều hành" },
  { role: "admin", label: "Holding Admin", desc: "Quản trị hệ thống holding" },
  { role: "manager", label: "Quản lý chi nhánh", desc: "Điều hành chi nhánh" },
  { role: "hr", label: "Nhân sự (HR)", desc: "Quản lý nhân sự, chấm công, lương" },
  { role: "finance", label: "Kế toán", desc: "Tài chính, thuế, OCR hóa đơn" },
  { role: "restaurant", label: "NV Phục vụ", desc: "Order tại bàn, POS" },
  { role: "kitchen", label: "NV Bếp", desc: "KDS, nhận order bếp" },
  { role: "warehouse", label: "NV Kho", desc: "Nhập/xuất kho, kiểm kê" },
];

export const WORKFLOWS = {
  ceo: [
    {
      id: "ceo-overview",
      title: "Tổng quan vận hành holding",
      desc: "Xem dashboard, KPI, lương, kho toàn hệ thống",
      steps: [
        { label: "Dashboard tổng quan", route: "/admin" },
        { label: "Sơ đồ tổ chức holding", route: "/admin/org-chart" },
        { label: "Pháp nhân & chi nhánh", route: "/admin/companies" },
        { label: "KPI toàn hệ thống", route: "/admin/kpi" },
        { label: "Lịch sử kiểm toán", route: "/admin/audit-history" },
      ],
    },
    {
      id: "ceo-legal",
      title: "Hồ sơ pháp lý holding",
      desc: "Vault pháp lý + phê duyệt grant",
      steps: [
        { label: "Mở Legal Vault", route: "/admin/legal-vault" },
        { label: "Yêu cầu truy cập", route: "/admin/legal-requests" },
        { label: "Grant đã cấp", route: "/admin/legal-grants" },
        { label: "Audit log pháp lý", route: "/admin/legal-audit" },
      ],
    },
  ],
  admin: [
    {
      id: "admin-setup",
      title: "Thiết lập hệ thống ban đầu",
      desc: "Master data, pháp nhân, vị trí, nhân sự",
      steps: [
        { label: "Master Data", route: "/admin/master" },
        { label: "Pháp nhân", route: "/admin/companies" },
        { label: "Vị trí công việc (HRM)", route: "/admin/hrm-positions" },
        { label: "Nhân sự", route: "/admin/employees" },
        { label: "Sơ đồ tổ chức", route: "/admin/org-chart" },
      ],
    },
    {
      id: "admin-audit",
      title: "Giám sát & kiểm toán",
      desc: "Xem audit log, dashboard sức khỏe hệ thống",
      steps: [
        { label: "Dashboard", route: "/admin" },
        { label: "Lịch sử kiểm toán", route: "/admin/audit-history" },
        { label: "Audit pháp lý", route: "/admin/legal-audit" },
      ],
    },
  ],
  manager: [
    {
      id: "manager-daily",
      title: "Vận hành chi nhánh hàng ngày",
      desc: "POS, kho, chấm công, KPI chi nhánh",
      steps: [
        { label: "Dashboard chi nhánh", route: "/admin" },
        { label: "POS - Quản lý bán hàng", route: "/admin/pos" },
        { label: "Kho - Tồn xuất nhập", route: "/admin/stock" },
        { label: "Chấm công nhân viên", route: "/admin/attendance" },
        { label: "Lịch ca làm việc", route: "/admin/shifts" },
        { label: "Công việc hàng ngày", route: "/admin/hrm-daily-work" },
        { label: "Sự cố / incidents", route: "/admin/hrm-incidents" },
      ],
    },
    {
      id: "manager-menu",
      title: "Quản lý menu & bếp",
      desc: "Cập nhật menu, theo dõi KDS",
      steps: [
        { label: "Menu & Guideline", route: "/admin/menu-guideline" },
        { label: "Bếp (KDS Admin)", route: "/admin/kitchen" },
        { label: "POS", route: "/admin/pos" },
      ],
    },
  ],
  hr: [
    {
      id: "hr-onboarding",
      title: "Tuyển dụng & onboarding nhân sự",
      desc: "Thêm nhân sự, ký hợp đồng, đào tạo",
      steps: [
        { label: "Onboarding nhân sự mới", route: "/admin/onboarding" },
        { label: "Danh sách nhân sự", route: "/admin/employees" },
        { label: "Hợp đồng lao động", route: "/admin/contracts" },
        { label: "Đào tạo (HRM)", route: "/admin/hrm-training" },
        { label: "Vị trí công việc", route: "/admin/hrm-positions" },
      ],
    },
    {
      id: "hr-payroll",
      title: "Chấm công & lương hàng tháng",
      desc: "Duyệt chấm công, tính lương, xuất bảng lương",
      steps: [
        { label: "Chấm công", route: "/admin/attendance" },
        { label: "Ca làm việc", route: "/admin/shifts" },
        { label: "KPI nhân viên", route: "/admin/kpi" },
        { label: "Tính lương (mới)", route: "/admin/payroll" },
        { label: "Excel Workspace", route: "/admin/excel" },
      ],
    },
  ],
  finance: [
    {
      id: "finance-monthly",
      title: "Đóng sổ tài chính tháng",
      desc: "OCR hóa đơn, lương, audit chi tiêu",
      steps: [
        { label: "OCR Hóa đơn (AI)", route: "/admin/ocr" },
        { label: "Lương (mới)", route: "/admin/payroll" },
        { label: "Lương (legacy)", route: "/admin/legacy-payroll" },
        { label: "Excel Workspace", route: "/admin/excel" },
        { label: "POS - Doanh thu", route: "/admin/pos" },
      ],
    },
  ],
  restaurant: [
    {
      id: "restaurant-shift",
      title: "Ca làm việc phục vụ",
      desc: "Chấm công, nhận task, lịch ca, payslip",
      steps: [
        { label: "Trang chủ Staff", route: "/staff" },
        { label: "Chấm công vào ca", route: "/staff/attendance" },
        { label: "Lịch ca làm việc", route: "/staff/schedule" },
        { label: "Công việc hôm nay", route: "/staff/tasks" },
        { label: "Công việc hàng ngày", route: "/staff/daily-work" },
        { label: "KPI cá nhân", route: "/staff/kpi" },
        { label: "Bảng lương cá nhân", route: "/staff/payslip" },
      ],
    },
    {
      id: "restaurant-legal",
      title: "Yêu cầu hồ sơ pháp lý",
      desc: "Gửi yêu cầu xem hồ sơ pháp lý holding",
      steps: [
        { label: "Tạo yêu cầu mới", route: "/staff/legal-request" },
      ],
    },
  ],
  kitchen: [
    {
      id: "kitchen-shift",
      title: "Ca làm việc bếp",
      desc: "Nhận order qua KDS, chấm công, KPI",
      steps: [
        { label: "Trang chủ Staff", route: "/staff" },
        { label: "Chấm công vào ca", route: "/staff/attendance" },
        { label: "KDS - Order bếp", route: "/staff/kds" },
        { label: "Công việc hôm nay", route: "/staff/tasks" },
        { label: "Lịch ca làm việc", route: "/staff/schedule" },
        { label: "KPI cá nhân", route: "/staff/kpi" },
        { label: "Bảng lương cá nhân", route: "/staff/payslip" },
      ],
    },
  ],
  warehouse: [
    {
      id: "warehouse-shift",
      title: "Ca làm việc kho",
      desc: "Chấm công, task nhập/xuất kho, KPI",
      steps: [
        { label: "Trang chủ Staff", route: "/staff" },
        { label: "Chấm công vào ca", route: "/staff/attendance" },
        { label: "Lịch ca làm việc", route: "/staff/schedule" },
        { label: "Công việc hôm nay", route: "/staff/tasks" },
        { label: "Công việc hàng ngày", route: "/staff/daily-work" },
        { label: "KPI cá nhân", route: "/staff/kpi" },
        { label: "Bảng lương cá nhân", route: "/staff/payslip" },
      ],
    },
    {
      id: "warehouse-legal",
      title: "Yêu cầu hồ sơ pháp lý",
      desc: "Gửi yêu cầu xem hồ sơ pháp lý holding",
      steps: [
        { label: "Tạo yêu cầu mới", route: "/staff/legal-request" },
      ],
    },
  ],
};

export function workflowsForRole(role) {
  return WORKFLOWS[role] || [];
}

export function findWorkflow(role, workflowId) {
  return (WORKFLOWS[role] || []).find((w) => w.id === workflowId) || null;
}
